// export const BASE_URL = 'https://laravel-regent-distribution.ddev.site';
// export const BASE_URL = 'https://regent-staging-api.medienreaktor-kunden.de';
export const BASE_URL = 'https://regent-api.medienreaktor-kunden.de';
export const DEBUG = false;